import zhCommon from './zh/common.json';
import zhGoogleSheet from './zh/google/sheet.json';
import zhGoogleField from './zh/google/field.json';
import zhFacebookSheet from './zh/facebook/sheet.json';
import zhFacebookField from './zh/facebook/field.json';

import enCommon from './en/common.json';
import enGoogleSheet from './en/google/sheet.json';
import enGoogleField from './en/google/field.json';
import enFacebookSheet from './en/facebook/sheet.json';
import enFacebookField from './en/facebook/field.json';

import jaCommon from './ja/common.json';
import jaGoogleSheet from './ja/google/sheet.json';
import jaGoogleField from './ja/google/field.json';
import jaFacebookSheet from './ja/facebook/sheet.json';
import jaFacebookField from './ja/facebook/field.json';

export const i18nMessages = {
  zh: {
    ...zhCommon,
    ...zhGoogleSheet,
    ...zhGoogleField,
    ...zhFacebookSheet,
    ...zhFacebookField,
  },
  en: {
    ...enCommon,
    ...enGoogleSheet,
    ...enGoogleField,
    ...enFacebookSheet,
    ...enFacebookField,
  },
  ja: {
    ...jaCommon,
    ...jaGoogleSheet,
    ...jaGoogleField,
    ...jaFacebookSheet,
    ...jaFacebookField
  },
};

export const REPORT_LANGUAGE = {
  zh: 'CHINESE',
  en: 'ENGLISH',
  ja: 'JAPANESE'
}

export const reportLangToI18n = {
  CHINESE: 'zh',
  ENGLISH: 'en',
  JAPANESE: 'ja',
};

export const languageFieldMap = {
  CHINESE: 'name_zh',
  ENGLISH: 'name_en',
  JAPANESE: 'name_ja',
}

export const languageMeta = [
  {
    code: 'zh',
    label: 'CHINESE',
    i18n: 'zh',
    field: 'name_zh',
  },
  {
    code: 'en',
    label: 'ENGLISH',
    i18n: 'en',
    field: 'name_en',
  },
  {
    code: 'ja',
    label: 'JAPANESE',
    i18n: 'ja',
    field: 'name_ja',
  },
];

export const nameFields = languageMeta.map(lang => lang.field).concat('name');

// 依 reportLanguage 設定指定 id 的 i18n 翻譯名稱
export const getManualTranslation = (id, reportLanguage = REPORT_LANGUAGE.zh) => {
  const i18nKey = reportLangToI18n[reportLanguage];
  return i18nMessages[i18nKey]?.[id] || '';
};

// 已選欄位資料：依 reportLanguage 設定指定欄位的 i18n 翻譯名稱
export const getSelectedOptionFieldsName = (media, field, reportLanguage = REPORT_LANGUAGE.zh) => {
  const i18nKey = reportLangToI18n[reportLanguage];
  const formatMedia = media?.toLowerCase();
  return i18nMessages[i18nKey]?.[`${formatMedia}.field.${field.expression}`] || field.name;
};

// 已選欄位的顯示名稱：使用欄位物件中的 name_xx 欄位
export const getDisplaySelectedFieldName = (field, reportLanguage = REPORT_LANGUAGE.zh) => {
  const nameKey = languageFieldMap[reportLanguage];
  if (nameKey && field[nameKey]) {
    return field[nameKey];
  }
  return field.name;
}

// 取得單一欄位名稱
export const getLocalizedFieldName = (media, field, reportLanguage, intl) => {
  const nameKey = languageFieldMap[reportLanguage];
  const formatMedia = media?.toLowerCase();

  // 優先使用對應語言的自訂名稱
  if (nameKey && field[nameKey]) {
    return field[nameKey];
  }

  // 自訂欄位，直接使用原始名稱
  if (field.type === 'custom') {
    return field.name;
  }

  return intl.formatMessage({
    id: `${formatMedia}.field.${field.expression}`,
    defaultMessage: field.name || field.expression,
  });
};

// 依 reportLanguage 設定上傳至伺服器的多個欄位資料
export const transformFieldsName = (media, fields, reportLanguage, intl) => {
  return fields.map((field) => {
    const translatedName = getLocalizedFieldName(media, field, reportLanguage, intl);
    return {
      ...field,
      name: translatedName,
    };
  });
};